<mat-tab-group
  *ngrxLet="patient$ as patient"
  class="mat-tab-icon-labels"
  [disablePagination]="true"
>
  <mat-tab>
    <ng-template matTabLabel>
      <mat-icon matTooltip="Patient Details">subject</mat-icon>
      <mat-icon
        *ngIf="(validPatientDetails$ | async) === false"
        class="has-notification"
        matTooltip="Missing Patient Details"
        color="warn"
      >
        warning
      </mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <pr-edit-patient-form
        #patientDetailsform
        class="tab-padding"
        [patient]="patient"
        [newPatientName]="newPatientName"
        [emitPatientDataOnUpdate]="true"
        [tabGroup]="tabGroup"
        (submitted)="patientDetailsSubmitted($event)"
      />
    </ng-template>
  </mat-tab>
  <mat-tab [disabled]="!patient">
    <ng-template matTabLabel>
      <mat-icon matTooltip="Healthcare Cards">local_hospital</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <div fxLayout="column" fxLayoutGap="32px" class="tab-padding">
        <ng-container *prIsRegion="[Region.Australia]">
          <div>
            <p class="font-bold">Medicare Card</p>
            <pr-medicare-card-form
              [medicareCard]="patient?.medicareCard"
              (medicareCardChange)="updatePatient({ medicareCard: $event })"
            />
          </div>
          <div>
            <p class="font-bold">DVA Card</p>
            <pr-dva-card-form
              [dvaCard]="patient?.dvaCard"
              (dvaCardChange)="updatePatient({ dvaCard: $event })"
            />
          </div>
        </ng-container>
        <ng-container *prIsRegion="[Region.NewZealand]">
          <div>
            <p class="font-bold">NHI</p>
            <div class="flex flex-col gap-2">
              <pr-national-health-index-number-form
                [nationalHealthIndexNumber]="patient?.nationalHealthIndexNumber"
                (nationalHealthIndexNumberChange)="
                  updatePatient({ nationalHealthIndexNumber: $event })
                "
              />
              @if (patient) {
                <div class="flex flex-col items-start gap-1">
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="mohService.sendEnrolmentForm(patient)"
                  >
                    Send MOH Enrolment Form
                  </button>
                  @if (
                    patient.metadata?.moh?.enrolmentFormSentAt;
                    as lastSent
                  ) {
                    <span class="text-xs text-gray-500">
                      Enrolment form previously sent on
                      {{ lastSent | moment | amDateFormat: dateFormat }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
          <div>
            <p class="font-bold">Health Insurance</p>
            <pr-health-insurance-details-form
              [healthInsuranceDetails]="patient?.healthInsuranceDetails"
              (healthInsuranceDetailsChange)="
                updatePatient({ healthInsuranceDetails: $event })
              "
            />
          </div>
        </ng-container>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab [disabled]="!patient">
    <ng-template matTabLabel>
      <mat-icon matTooltip="Relationships">group</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <div class="tab-padding">
        <pr-patient-primary-contact-form
          [formData]="primaryContactData$ | async"
          [autoSave]="true"
          (primaryContactChange)="primaryContactChange($event)"
        />
        <pr-patient-relationship-form
          [formData]="relationshipData$ | async"
          [autoSave]="true"
          (relationshipChange)="relationshipChange($event)"
        />
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
